// removed by extract-text-webpack-plugin
module.exports = {"book":"book_2UGjt","maximize":"maximize_J4ARK"};


//////////////////
// WEBPACK FOOTER
// ./app/components/book/styles.scss
// module id = 415
// module chunks = 1